import React from 'react';
interface WizardProgressProps {
  currentStep: number;
  totalSteps: number;
}
export const WizardProgress: React.FC<WizardProgressProps> = ({
  currentStep,
  totalSteps
}) => {
  const steps = [{
    number: 1,
    label: "Let's create your fantasy scenario"
  }, {
    number: 2,
    label: 'Choose your fantasy theme'
  }, {
    number: 3,
    label: 'Personalize your scenario'
  }, {
    number: 4,
    label: 'Preview your fantasy'
  }, {
    number: 5,
    label: 'Fantasy unleashed'
  }, {
    number: 6,
    label: 'Complete'
  }];
  return <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-800" data-id="element-22351">
      <div className="flex items-center justify-between" data-id="element-22352">
        {steps.map(step => <div key={step.number} className={`flex flex-col items-center ${step.number === currentStep ? 'text-pink-500' : step.number < currentStep ? 'text-gray-500' : 'text-gray-300 dark:text-gray-600'}`} data-id="element-22353">
            <div className={`w-8 h-8 rounded-full flex items-center justify-center mb-1 ${step.number === currentStep ? 'bg-pink-100 dark:bg-pink-900/30 text-pink-500 border-2 border-pink-500' : step.number < currentStep ? 'bg-pink-500 text-white' : 'bg-gray-100 dark:bg-gray-800 text-gray-400'}`} data-id="element-22354">
              {step.number < currentStep ? '✓' : step.number}
            </div>
            <span className="text-xs" data-id="element-22355">{step.label}</span>
          </div>)}
      </div>
      <div className="relative mt-2" data-id="element-22356">
        <div className="absolute top-0 left-0 h-1 bg-gray-200 dark:bg-gray-700 w-full rounded-full" data-id="element-22357"></div>
        <div className="absolute top-0 left-0 h-1 bg-gradient-to-r from-pink-500 to-purple-500 rounded-full transition-all" style={{
        width: `${(currentStep - 1) / (totalSteps - 1) * 100}%`
      }} data-id="element-22358"></div>
      </div>
    </div>;
};